export const projects = [
  {
    id: 1,
    title: "Medline",
    description: "Deployed enterprise chatbot solutions using Microsoft Copilot Studio, delivering intelligent automation across multiple business channels including Microsoft Teams and SharePoint for both vendor-facing and internal user applications",
    tech: ["Python", "C#", "Microsoft Foundry", "Microsoft Copilot Studio", "Power Platform", "Azure AI Search", "Pinecone", "Azure OpenAI", "Azure AI Builder", "RAG"],
    demo: "#",
    github: "#",
    image: "/api/placeholder/400/250"
  },
  {
    id: 2,
    title: "AT&T",
    description: "Developed and optimized AI and Automation solutions using Microsoft Copilot Studio, Azure AI Foundry, and Custom APIs to enhance conversational AI capabilities.",
    tech: ["C#", "Python","Power Platform","Copilot Studio","ReactJS", "Node.js","Dynamics 365"],
    demo: "#",
    github: "#",
    image: "/api/placeholder/400/250"
  },
  {
    id: 3,
    title: "Pramati Technologies",
    description: "Developed an All-in-one HRMS platform with modules like Employee Management, Onboarding, Payroll, Taxation etc.",
    tech: ["Python", "C#", ".NET Framework", "Power Apps", "SharePoint", "Azure Bot Service", "Microsoft Bot Framework"],
    demo: "#",
    github: "#",
    image: "/api/placeholder/400/250"
  }
];